import { CheckoutUserFlowEnum } from 'components/views/pages/Checkout/types';
import { LoginFormikForm, LoginFormikValues } from 'components/views/pages/login/LoginFormikForm';
import { LoginModeEnum } from 'components/views/pages/login/types';
import { FormikHelpers } from 'formik';
import { Dispatch, SetStateAction } from 'react';
import { userQueryKey, useQueryClient } from '@alluradirect/react';
import { useAppUserLoginMutation } from 'hooks/api/user/mutations/auth/useAppUserLogin';

interface Props {
  initialEmail: string;
  close: () => void;
  setCheckoutUserFlowStep: Dispatch<SetStateAction<CheckoutUserFlowEnum>>;
}

export const CheckoutLoginForm = ({ initialEmail, setCheckoutUserFlowStep, close }: Props) => {
  const qClient = useQueryClient();
  const userLoginMutation = useAppUserLoginMutation({
    onSuccess: () => {
      qClient.resetQueries({ queryKey: [userQueryKey] });
      qClient.resetQueries({ queryKey: ['checkout'] });
      qClient.resetQueries({ queryKey: ['GUEST_BOOKING'] });
      close();
    },
  });

  const onSubmit = async (values: LoginFormikValues, helpers: FormikHelpers<LoginFormikValues>) => {
    userLoginMutation.mutate(values, {
      onSettled: () => {
        helpers.setSubmitting(false);
      },
    });
  };

  return (
    <LoginFormikForm
      initialValues={{ email: initialEmail, password: '', submit: '' }}
      onSubmit={onSubmit}
      mode={LoginModeEnum.host}
      hasLoginFormFooter={false}
      hasTopAppDivider={false}
      isEmailFieldDisabled={!!initialEmail}
      onClickForgotPassword={() => setCheckoutUserFlowStep(CheckoutUserFlowEnum.ForgotPassword)}
    />
  );
};
